import moment from 'moment';
import cpdTimeFormatter from './cpdTimeFormatter';

export default (() => {

    function formatAddress(address) {

        const addressLine2 = address.address_2 ? address.address_2 + ', ' : '';

        return address.address_1 + ', ' + addressLine2 + address.town_city + ', ' + address.post_code;
    }

    function areDatesOnSameDay(startDate, endDate) {

        const dateFormat = 'YYYY-MM-DD';

        return startDate.format(dateFormat) === endDate.format(dateFormat)
    }

    function formatDateRange(start, end) {

        const startDate = moment(start);
        const endDate   = moment(end);

        const dateTimeFormat = 'DD MMMM YYYY HH:mm';

        const formattedStartDate = startDate.format(dateTimeFormat);
        var formattedEndDate     = endDate.format(dateTimeFormat);

        if (areDatesOnSameDay(startDate, endDate)) {

            formattedEndDate = endDate.format('HH:mm');
        }

        return formattedStartDate + '–' + formattedEndDate;
    }

    function format(event) {

        var formattedEvent = { ...event };

        if (formattedEvent.multiple_days) {

            formattedEvent.multiple_days_events.map((multiDayEvent) => {

                multiDayEvent.date_range = formatDateRange(multiDayEvent.start_date, multiDayEvent.end_date);
            })

        } else {

            formattedEvent.date_range = formatDateRange(event.start_date, event.end_date);
        }

        if (event.course) {

            formattedEvent.padded_cpd_hours   = cpdTimeFormatter.formatHours(event.course.cpd_hours);
            formattedEvent.padded_cpd_minutes = cpdTimeFormatter.formatMinutes(event.course.cpd_minutes);
        }
        
        if (event.venue && event.venue.address) {

            formattedEvent.venue_address_text = formatAddress(event.venue.address);
        }

        return formattedEvent;
    }

    function getFormattedEventDate(event) {

        return moment(event.start_date).format('DD MMMM YYYY');
    }

    function getFormattedEventStartTime(event) {

        return moment(event.start_date).format('HH:mm');
    }

    function getFormattedEventEndTime(event) {

        return moment(event.end_date).format('HH:mm');
    }

    return {
        format,
        getFormattedEventDate,
        getFormattedEventStartTime,
        getFormattedEventEndTime
    };

})();


// WEBPACK FOOTER //
// ./services/eventFormatter.js